<template>
	<header class="header-class">
		<div class="header-main d-flex justify-content-between align-items-center">
			<div class="d-flex">
				<div class="pointer">
					<img
						@click="expandSideBar"
						v-if="!menuStatus"
						src="../../assets/icons/sidenav/Menu icon.svg"
						alt=""
					/>
					<img
						v-else
						src="../../assets/icons/sidenav/MenuActive.svg"
						alt=""
						@click="closeSideBar"
					/>
				</div>
				<div class="ml-3 mr-2 align-items-center d-flex">
					<img
						src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg"
						style="display: block; visibility: visible; opacity: 1"
						alt=""
					/>
				</div>
				<div class="d-flex align-items-center">
					<div class="cv-bulders-path d-flex align-items-center">
						<router-link :to="{ path: `${roleValues.landingPage}` }">
							<h6 class="m-0 hover-color">Assessment</h6>
						</router-link>
						<span class="d-flex align-items-center"
							><img
								class="mr-2 mb-1"
								src="../../assets/path-forward.svg"
								alt=""
						/></span>
					</div>
					<div>
						<b-breadcrumb>
							<b-breadcrumb-item
								class="d-flex"
								v-for="(item, index) in levelList"
								:key="item.path"
								:active-class="item.meta.title"
								:active="item.active"
							>
								<div
									v-b-tooltip.hover.top="item.meta.title"
									v-if="
										item.redirect === 'noRedirect' ||
										index == levelList.length - 1
									"
									:class="
										!isSearchVisible && index > levelList.length - 2
											? 'text-truncate w-260px'
											: isSearchVisible && item.meta.title.length > 24
											? 'breadcrumb-ellipsis2'
											: isSearchVisible && item.meta.title.length > 24
											? 'breadcrumb-ellipsis'
											: ''
									"
									class="no-redirect"
								>
									{{ item.meta.title }}
								</div>
								<div
									:class="item.meta.title == '...' ? 'dot-class' : ''"
									class="breadcrumbs-active-class pointer"
									v-b-tooltip.hover.top="
										item.meta.breadcrumbTitle || item.meta.title
									"
									v-else
									@click.prevent="handleLink(item)"
								>
									{{ item.meta.title }}
								</div>
							</b-breadcrumb-item>
						</b-breadcrumb>
					</div>
				</div>
			</div>
			<div
				style="width: 40%"
				class="position-relative search-bar"
				v-show="!sharePage"
			>
				<span class="search-pos">
					<img src="../../assets/searchicon.svg" alt=""
				/></span>
				<b-form-input
					class="search-input"
					@keyup="searchTest()"
					@input="searchTest()"
					v-model="searchTopicTest"
					type="search"
					:placeholder="`Search ${Assesment}`"
					id="headerSearch"
				></b-form-input>
			</div>

			<!-- <div class="login-details">
        <div class="d-flex align-items-center">
          <div
            class="profile-details d-flex align-items-center text-capitalize"
          >
            <h6 class="m-0">{{ roleValues.username }}</h6>
          </div>
          <div class="mr-2 pointer" @click="showdpcard = !showdpcard">
            <img src="../../assets/profile.svg" alt="" />
            <img
              v-if="!showdpcard"
              class="ml-1"
              src="../../assets/icons/header/downarrow.svg"
              alt=""
            />
            <img
              v-else
              class="ml-1"
              src="../../assets/icons/header/uparrow.svg"
              alt=""
            />
          </div>
          <div class="d-flex" v-b-hover="handleHover">
            <div class="mr-3 relativeclass switchtext pointer">
              <div v-if="showdpcard">
                <div class="tnt-sortcard headercard p-0 z-20">
                  <div
                    style="background: #f4f4f4; color: #5787ff"
                    class="p-2"
                    @click="
                      $router.push({
                        name: 'Profile'
                      })
                    "
                  >
                    PROFILE
                  </div>
                  <div
                    style="background: #fdfdfd; color: #b00101"
                    class="p-2"
                    @click="logout()"
                  >
                    LOG OUT
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
			<!-- switch apps -->

			<div class="position-relative d-flex align-items-center ml-2">
				<div class="position-relative mr-2" v-if="count > 1">
					<div
						class="sp-active-main-container pointer"
						@click="showswitch = !showswitch"
						ref="switch"
					>
						<img src="../../assets/switchapps/Sappsmain.svg" alt="" />
						<img
							v-show="!showswitch"
							src="../../assets/switchapps/chevron-down.svg"
							class="ml-2"
							alt=""
						/>
						<img
							v-show="showswitch"
							src="../../assets/switchapps/chevron-up.svg"
							class="ml-2"
							alt=""
						/>
					</div>
					<div
						class="allproj-dropdown"
						v-if="showswitch"
						ref="switch-body"
						v-closable="{
							exclude: ['switch-body', 'switch'],
							handler: 'closeSwitch',
						}"
					>
						<div class="allproj-card" v-if="accessCandidate" @click="openCan">
							<img src="../../assets/All-projects-icons/cand.svg" alt="" />

							<div class="allproj-card-head">Candidates</div>

							<div class="allproj-card-subhead">
								Login to resume builder, much more
							</div>
						</div>

						<div class="allproj-card allproj-card-selected">
							<img src="../../assets/All-projects-icons/assess.svg" alt="" />

							<div class="allproj-card-head">Assessment</div>

							<div class="allproj-card-subhead">
								Create, manage assessment progress
							</div>
						</div>
						<div
							class="allproj-card"
							v-if="accessRecruitment"
							@click="openRecruit"
						>
							<img src="../../assets/All-projects-icons/rec.svg" alt="" />

							<div class="allproj-card-head">Recruiters</div>

							<div class="allproj-card-subhead">
								Build & hire from our network, AI features
							</div>
						</div>
						<div class="allproj-card" v-if="accessTraining" @click="openTrain">
							<img src="../../assets/All-projects-icons/training.svg" alt="" />

							<div class="allproj-card-head">Training</div>

							<div class="allproj-card-subhead">
								Create, manage & edit course videos
							</div>
						</div>
					</div>
				</div>
				<div
					class="login-det-container pointer d-flex align-items-center"
					@click="showdpcard = !showdpcard"
					ref="log-label"
				>
					<div>
						<img src="../../assets/icons/header/defaultprofilepic.svg" alt="" />
					</div>
					<div class="d-flex align-items-center text-capitalize ml-1">
						<span class="welcometext">Welcome,</span> &nbsp;
						<span class="username"> {{ roleValues.username }}</span>
					</div>
				</div>
				<div
					class="logoutbox mt-2 pointer"
					v-if="showdpcard"
					ref="log-body"
					v-closable="{
						exclude: ['log-body', 'log-label'],
						handler: 'closeLog',
					}"
				>
					<div
						class="dropdown-head dropdown-sub p-2"
						@click="
							$router.push({
								name: 'Profile',
							})
						"
					>
						My Profile
					</div>

					<div
						class="d-flex align-items-center justify-content-center p-2"
						@click="logout"
					>
						<img src="../../assets/icons/header/logout.svg" alt="" />
						<span class="ml-2 logout-txt">LOG OUT</span>
					</div>
					<!-- <b-popover
              triggers="click"
              target="switch-app"
              id="switchapp-popover"
            >
            <div style="width: 205px;">
              <div class="p-2 dropdown-active">Assessment</div>
              <div class="p-2" :class="accessRecruitment?'dropdown-options pointer':'disable-dropdown-options'" @click="openRecruit">Recruitment</div>
              <div class="p-2" :class="accessTraining?'dropdown-options pointer':'disable-dropdown-options'">Training</div>
              <div class="p-2" :class="accessCandidate?'dropdown-options pointer':'disable-dropdown-options'" @click="openCan">Candidate</div>
            </div>
            </b-popover> -->
				</div>
			</div>
		</div>
		<b-modal
			id="preferencemodal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="prefmodalheading d-flex align-items-center">
				Preference settings
			</div>
			<div class="mt-1 prefmodal-subhead">
				Let us know where we need to direct you once you login.You can later
				change this preference in settings.
			</div>
			<div class="prefmodal-radios mt-3">
				<b-form-radio
					v-if="accessRecruitment"
					v-model="selected"
					value="recruitment"
					>Recruitment</b-form-radio
				>
				<b-form-radio
					v-if="accessAssessment"
					v-model="selected"
					value="assessment"
					>Assessment</b-form-radio
				>
				<b-form-radio v-if="accessTraining" v-model="selected" value="training"
					>Training</b-form-radio
				>
				<b-form-radio
					v-if="accessCandidate"
					v-model="selected"
					value="candidate"
					>Candidate</b-form-radio
				>
			</div>
			<hr
				style="
					border-bottom: 1px solid rgba(128, 128, 128, 0.2);
					margin-top: 10px;
				"
			/>
			<div class="prefmodal-checkbox">
				<b-form-checkbox id="checkbox-1" v-model="status">
					Don’t show me this message again.
				</b-form-checkbox>
			</div>
			<div
				class="mt-4 d-flex align-items-center justify-content-end prefmodal-btns"
			>
				<b-button variant="light" @click="closeval()">Cancel</b-button>
				<b-button variant="primary ml-2" @click="setPref()">Apply</b-button>
			</div>
		</b-modal>
	</header>
</template>
<script>
import { mapGetters } from "vuex";
const { compile } = require("path-to-regexp");
import { postPreference, getPreference } from "../../utils/apiFunctions";
import { getShowPreference, setShowPreference } from "../../utils/tokenCheck";
import successToast from "../../views/mixin/toast";
export default {
	name: "Header",
	data() {
		return {
			searchTopicTest: "",
			Assesment: "Topics",
			count: 1,
			showopt: false,
			sharePage: false,
			showdpcard: false,
			showswitch: false,
			levelList: null,
			status: false,
			selected: null,
			accessRecruitment: false,
			accessTraining: false,
			accessCandidate: false,
			accessAssessment: true,
			preferences: {},
		};
	},
	mixins: [successToast],
	computed: {
		isSearchVisible() {
			return !this.sharePage;
		},
		...mapGetters("userVUEX", {
			getlogoutRedirect: "getlogoutRedirect",
			// getShowPref: "getShowPref",
			loggedin: "checkLoginStatus",
			tagname: "getTagName",
			roleValues: "getRoleValues",
			menuStatus: "getMenuStatus",
		}),
		...mapGetters("topicVUEX", {
			selectedTopic: "getSelectedTopic",
		}),
		...mapGetters("testVUEX", {
			testConfig: "getTestConfigData",
			selectedTest: "getSelectedTest",
		}),
		...mapGetters("sectionVUEX", {
			selectedSection: "getSelectedSection",
		}),
		...mapGetters("autotestVUEX", {
			autotest: "getAutoSelectedTest",
		}),
		...mapGetters("searchVUEX", {
			selectedReportDetails: "getReportsDetails",
			selectedInd: "getSelectedIndGrp",
		}),
		switchBreadcrumbs() {
			let matched = this.$route.matched.filter((item) => {
				if (this.configureTest()) {
					if (item.name != undefined) {
						return item.meta?.title;
					}
				} else {
					return item.meta?.title;
				}
			});
			let codematched;
			let editmatched;
			switch (this.$route.name) {
				case "Home":
					matched.splice(0, 0, {
						name: "Home",
						meta: { title: "Topics" },
					});
					return matched;
				case "Tests":
					matched.splice(
						1,
						0,
						{
							name: "Home",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: { title: "Topics" },
						},
						{
							name: "Tests",
							meta: { title: "Tests" },
						}
					);
					return matched;
				case "QPBuilder":
					matched.splice(
						1,
						0,
						{
							path: "/",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: { title: "Topics" },
						},
						{
							name: "Tests",
							params: {
								topicID: this.$route.params.topicID,
								topicName: this.$route.params.topicName,
							},
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
								ttype: this.$route.query.ttype,
								tsort: this.$route.query.tsort,
							},
							meta: {
								title: "...",
								breadcrumbTitle: this.$route.params.topicName,
							},
						},
						{
							redirect: `noRedirect`,
							meta: { title: this.$route.params.testName },
						},
						{ redirect: `noRedirect`, meta: { title: "Sections" } }
					);
					return matched;
				case "ShareWithPeople":
				case "ShareWithPeopleTest":
					matched.splice(
						0,
						0,
						{
							path: "/",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: { title: "Topics" },
						},
						// {
						//   name: "Tests",
						//   params: {
						//     topicID: this.$route.params.topicID,
						//     topicName: this.selectedTopic.topicName,
						//   },
						//   meta: { title: this.selectedTopic.topicName },
						// },
						// {
						//   name: "QPBuilder",
						//   params: {
						//     testName: this.selectedTest.testName,
						//     testID: this.$route.params.testID,
						//     topicName: this.selectedTopic.topicName,
						//     topicID: this.$route.params.topicID,
						//   },
						//   meta: { title: this.selectedTest.testName },
						// },
						{
							name: `QPBuilder`,
							params: {
								testName: this.selectedTest.testName,
								testID: this.$route.params.testID,
								topicName: this.selectedTopic.topicName,
								topicID: this.$route.params.topicID,
							},
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
								ttype: this.$route.query.ttype,
								tsort: this.$route.query.tsort,
								status: this.$route.query.status,
							},
							meta: {
								title: "...",
								breadcrumbTitle: this.selectedTest.testName,
							},
						}
					);
					return matched;
				case "Configure":
					matched.splice(
						0,
						0,
						{
							path: "/",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: { title: "Topics" },
						},
						// {
						//   name: "Tests",
						//   params: {
						//     topicID: this.$route.params.topicID,
						//     topicName: this.selectedTopic.topicName,
						//   },
						//   meta: { title: this.selectedTopic.topicName },
						// },
						{
							name: "QPBuilder",
							params: {
								testName: this.selectedTest.testName,
								testID: this.$route.params.testID,
								topicName: this.selectedTopic.topicName,
								topicID: this.$route.params.topicID,
							},
							// meta: { title: this.selectedTest.testName },
							meta: {
								title: "...",
								breadcrumbTitle: "Sections",
							},
						},
						{
							path: `/share/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}`,
							query: {
								autoqp: this.$route.query.autoqp,
								testqp: this.$route.query.testqp,
							},
							meta: { title: `Share` },
						}
					);
					return matched;
				case "ViewConfiguration":
				case "EditConfiguration":
				case "ParticularTestConfiguration":
					matched.splice(
						0,
						0,
						{
							path: "/",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: { title: "Topics" },
						},
						// {
						//   name: "QPBuilder",
						//   params: {
						//     testName: this.selectedTest.testName,
						//     testID: this.$route.params.testID,
						//     topicName: this.selectedTopic.topicName,
						//     topicID: this.$route.params.topicID
						//   },
						//   // meta: { title: this.selectedTest.testName },
						//   meta: {
						//     title: "...",
						//     breadcrumbTitle: "Sections"
						//   }
						// },
						{
							name: "ShareWithPeople",
							params: {
								testName: this.selectedTest.testName,
								testID: this.$route.params.testID,
								topicName: this.selectedTopic.topicName,
								topicID: this.$route.params.topicID,
							},
							// meta: { title: this.selectedTest.testName },
							meta: {
								title: "...",
								breadcrumbTitle: "Share",
							},
							query: {
								autoqp: this.$route.query.autoqp,
								testqp: this.$route.query.testqp,
							},
						},
						{
							//  `/share/configure/${this.$route.params.testID}/${this.$route.params.topicID}/${group.groupID}/${group.candidateType}`
							redirect: `/share/configure/${this.$route.params.testID}/${this.$route.params.topicID}/${this.$route.params.groupID}/${this.$route.params.groupType}`,
							meta: { title: `Configure` },
						}
					);
					return matched;
				case "ViewConfigurationTest":
				case "EditConfigurationTest":
				case "ParticularTestConfigurationTest":
					matched.splice(
						0,
						0,
						{
							path: "/",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: { title: "Topics" },
						},
						// {
						//   name: "Tests",
						//   params: {
						//     topicID: this.$route.params.topicID,
						//     topicName: this.selectedTopic.topicName,
						//   },
						//   meta: { title: this.selectedTopic.topicName },
						// },
						// {
						//   name: "QPBuilder",
						//   params: {
						//     testName: this.selectedTest.testName,
						//     testID: this.$route.params.testID,
						//     topicName: this.selectedTopic.topicName,
						//     topicID: this.$route.params.topicID
						//   },
						//   // meta: { title: this.selectedTest.testName },
						//   meta: {
						//     title: "...",
						//     breadcrumbTitle: "Sections"
						//   }
						// },
						{
							name: "ShareWithPeopleTest",
							params: {
								topicID: this.$route.params.topicID,
								testID: this.$route.params.testID,
							},
							// meta: { title: this.selectedTest.testName },
							meta: {
								title: "...",
								breadcrumbTitle: "Share",
							},
							query: {
								autoqp: this.$route.query.autoqp,
								testqp: this.$route.query.testqp,
							},
						},
						{
							redirect: `/configure/${this.$route.params.testID}/${this.$route.params.topicID}/${this.$route.params.groupID}/${this.$route.params.groupType}`,
							meta: { title: `Configure` },
						}
					);
					return matched;
				case "ConfigureTest":
					matched.splice(
						0,
						0,
						// {
						//   redirect: "/",
						//   meta: { title: this.selectedTopic.topicName },
						// },

						{
							path: "/",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: { title: "Topics" },
						},
						// {
						//   name: "Tests",
						//   params: {
						//     topicID: this.$route.params.topicID,
						//     topicName: this.selectedTopic.topicName,
						//   },
						//   meta: { title: this.selectedTopic.topicName },
						// },
						{
							name: "QPBuilder",
							params: {
								testName: this.selectedTest.testName,
								testID: this.$route.params.testID,
								topicName: this.selectedTopic.topicName,
								topicID: this.$route.params.topicID,
							},
							// meta: { title: this.selectedTest.testName },
							meta: {
								title: "...",
								breadcrumbTitle: "Sections",
							},
						},
						{
							path: `/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}`,
							meta: { title: `Share` },
							query: {
								autoqp: this.$route.query.autoqp,
								testqp: this.$route.query.testqp,
							},
						}
					);
					return matched;
				case "ViewProctorTestScreen":
					console.log(matched);
					matched.splice(
						0,
						0,
						{
							path: `/proctoring`,
							query: {
								summary: this.$route.query.summary,
								evaluated: this.$route.query.evaluated,
								groups: this.$route.query.groups,
							},
							meta: {
								title: "Proctoring",
							},
						},
						{
							redirect: `noRedirect`,
							meta: {
								title: this.$route.query.name,
								breadcrumbTitle: this.$route.query.name,
							},
						}
					);
					return matched;
				case "ViewCandidateProctorScreen":
					matched.splice(
						1,
						0,
						{
							path: `/proctoring/ViewProctorTestScreen/${this.$route.params.testID}/${this.$route.params.topicID}/${this.$route.params.testName}`,
							meta: { title: this.$route.params.testName },
						},
						{
							redirect: "noRedirect",
							meta: { title: this.$route.query.emailName },
						}
					);
					return matched;
				case "candidateproctor":
					matched.splice(
						1,
						0,
						{
							path: `/proctoring`,
							query: {
								summary: this.$route.query.summary,
								evaluated: this.$route.query.evaluated,
								groups: this.$route.query.groups,
							},
							meta: {
								title: "Proctoring",
								breadcrumbTitle: "Proctoring",
							},
						},
						{
							path: `/proctoring/proctortest/${this.$route.params.groupID}/${this.$route.params.candidateType}`,
							query: {
								name: this.$route.query.name,
								summary: this.$route.query.summary,
								evaluated: this.$route.query.evaluated,
								groups: this.$route.query.groups,
								sort: this.$route.query.sort,
								status: this.$route.query.status,
							},
							meta: {
								title: "...",
								breadcrumbTitle: this.$route.query.name,
							},
						},
						{
							redirect: `noRedirect`,
							meta: {
								title: "Candidate Proctoring Details",
							},
						}
					);
					return matched;
				case "createprojects":
					matched.splice(
						0,
						1,
						{
							path: "/myprojects",
							meta: { title: "My Projects" },
						},
						{
							redirect: `noRedirect`,
							meta: { title: "Create Project" },
						}
					);
					return matched;
				case "TopicReport":
					matched = [
						{ path: "/reports", meta: { title: "Assessment Reports" } },
						{
							redirect: `noRedirect`,
							meta: { title: this.selectedReportDetails.topicName },
						},
					].concat(matched);
					return matched;
				case "IndividualTest":
					matched = [
						{ path: "/reports", meta: { title: "Assessment Reports" } },
						{
							path: `/reports/topic/${this.$route.params.topicID}`,
							meta: { title: this.selectedReportDetails.topicName },
						},
						{
							redirect: `noRedirect`,
							meta: { title: this.selectedReportDetails.testName },
						},
					].concat(matched);
					return matched;
				case "CandidatePerformance":
					matched = [
						{ path: "/reports", meta: { title: "Assessment Reports" } },
						{
							path: `/reports/topic/${this.selectedReportDetails.topicID}`,
							meta: { title: this.selectedReportDetails.topicName },
						},
						{
							redirect: `/reports/test/${this.selectedReportDetails.topicID}/${this.$route.params.testID}`,
							meta: { title: this.selectedReportDetails.testName },
						},
						{
							redirect: `noRedirect`,
							meta: { title: this.$route.params.candidateName },
						},
					].concat(matched);
					return matched;
				case "ShareWithPeopleAutogenerate":
				case "ShareWithPeopleAutoQPBuilder":
					matched = [
						{
							path: "/autogenerate",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: { title: "AutoGenerate Test" },
						},
						{
							name: "AutoQPBuilder",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
								status: this.$route.query.status,
							},
							params: {
								testID: this.$route.params.testID,
								testName: this.$route.params.testName,
							},

							meta: {
								title: "...",
								breadcrumbTitle: this.$route.params.testName,
							},
						},
					].concat(matched);
					return matched;
				case "ConfigureAutogenerate":
					matched = [
						{
							path: "/autogenerate",
							meta: { title: "AutoGenerate Test" },
						},
						{
							name: "AutoQPBuilder",
							params: {
								testID: this.$route.params.testID,
								testName: this.$route.params.testName,
							},
							meta: {
								title: "...",
								breadcrumbTitle: `Sections`,
							},
						},
						{
							name: "ShareWithPeopleAutogenerate",
							params: {
								topicID: this.$route.params.topicID,
								testID: this.$route.params.testID,
								testName: this.$route.params.testName,
							},
							meta: { title: "Share" },
							query: {
								autoqp: this.$route.query.autoqp,
								testqp: this.$route.query.testqp,
							},
						},
					].concat(matched);
					return matched;
				case "ConfigureAutoQPBuilder":
					matched = [
						{
							path: "/autogenerate",
							meta: { title: "AutoGenerate Test" },
						},
						{
							name: "AutoQPBuilder",
							params: {
								testID: this.$route.params.testID,
								testName: this.$route.params.testName,
							},
							meta: {
								title: "...",
								breadcrumbTitle: `Sections`,
							},
						},
						{
							name: "ShareWithPeopleAutoQPBuilder",
							params: {
								topicID: this.$route.params.topicID,
								testID: this.$route.params.testID,
								testName: this.$route.params.testName,
							},
							meta: { title: "Share" },
							query: {
								autoqp: this.$route.query.autoqp,
								testqp: this.$route.query.testqp,
							},
						},
					].concat(matched);
					return matched;
				case "EditConfigurationAutoQPBuilder":
				case "ParticularTestConfigurationAutoQPBuilder":
				case "ViewConfigurationAutoQPBuilder":
					matched = [
						{ path: "/autogenerate", meta: { title: "AutoGenerate Test" } },
						// {
						//   name: "AutoQPBuilder",
						//   params: {
						//     testID: this.$route.params.testID,
						//     testName: this.$route.params.testName
						//   },
						//   meta: {
						//     title: "...",
						//     breadcrumbTitle: `Sections`
						//   }
						// },
						{
							name: "ShareWithPeopleAutoQPBuilder",
							params: {
								topicID: this.$route.params.topicID,
								testID: this.$route.params.testID,
								testName: this.$route.params.testName,
							},
							meta: {
								title: "...",
								breadcrumbTitle: `Share`,
							},
							query: {
								autoqp: this.$route.query.autoqp,
								testqp: this.$route.query.testqp,
							},
						},
						{
							redirect: `/qp/configure/${this.$route.params.testID}/${this.$route.params.groupID}/${this.$route.params.topicID}/${this.$route.params.testName}/${this.$route.params.groupType}`,
							meta: { title: `Configure` },
						},
					].concat(matched);
					return matched;
				case "ViewConfigurationAutogenerate":
				case "EditConfigurationAutogenerate":
				case "ParticularTestConfigurationAutogenerate":
					matched = [
						{ path: "/autogenerate", meta: { title: "AutoGenerate Test" } },
						// {
						//   name: "AutoQPBuilder",
						//   params: {
						//     testID: this.$route.params.testID,
						//     testName: this.$route.params.testName
						//   },
						//   meta: {
						//     title: "...",
						//     breadcrumbTitle: `Sections`
						//   }
						// },
						{
							name: "ShareWithPeopleAutogenerate",
							params: {
								topicID: this.$route.params.topicID,
								testID: this.$route.params.testID,
								testName: this.$route.params.testName,
							},
							meta: {
								title: "...",
								breadcrumbTitle: `Share`,
							},
							query: {
								autoqp: this.$route.query.autoqp,
								testqp: this.$route.query.testqp,
							},
						},
						{
							redirect: `/autogenerate/configure/${this.$route.params.testID}/${this.$route.params.groupID}/${this.$route.params.topicID}/${this.$route.params.testName}/${this.$route.params.groupType}`,
							meta: { title: `Configure` },
						},
					].concat(matched);
					return matched;
				case "ProctoringDashboard":
					matched.splice(0, 0, {
						path: `/proctoring`,
						query: {
							summary: this.$route.query.summary,
							evaluated: this.$route.query.evaluated,
							groups: this.$route.query.groups,
						},
						meta: {
							title: "Proctoring",
						},
					});
					return matched;
				case "Archivetest":
					matched.splice(
						1,
						0,
						{
							name: "Home",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: {
								title: "Topics",
							},
						},
						{
							redirect: `noRedirect`,
							meta: {
								title: "Inactive Tests",
							},
						}
					);
					return matched;
				case "AutogenerateTest":
					matched.splice(0, 2, {
						name: "AutogenerateTest",
						meta: {
							title: "AutoGenerate Test",
						},
					});
					return matched;
				case "AutoQPBuilder":
					matched.splice(
						1,
						0,
						{
							name: "AutogenerateTest",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: {
								title: "AutoGenerate Test",
							},
						},
						{
							redirect: `noRedirect`,
							meta: { title: this.$route.params.testName },
						},
						{
							redirect: `noRedirect`,
							meta: { title: "Sections" },
						}
					);
					return matched;
				case "AutogenerateSection":
					matched.splice(
						1,
						0,
						{
							name: "AutogenerateTest",
							query: {
								type: this.$route.query.type,
								sort: this.$route.query.sort,
							},
							meta: {
								title: "AutoGenerate Test",
							},
						},
						{
							redirect: `noRedirect`,
							meta: { title: "Auto Section" },
						}
					);
					return matched;
				case "tryCode":
					matched.splice(
						0,
						0,
						{
							name: "QPCodingTest",
							meta: { title: "QP Coding Test" },
						},
						{
							name: "tryCode",
							query: {
								questionKey: this.$route.query.questionKey,
							},
							meta: { title: "Try Question" },
						}
					);
					return matched;
				case "BuildingCodeTest":
					matched.splice(0, 0, {
						name: "BuildingCodeTest",
						query: {
							questionKey: this.$route.query.questionKey,
						},
						meta: { title: "Create Question" },
					});
					if (this.$route.query.redirect == "QPBuilder") {
						codematched = [
							{
								path: "/",
								query: {
									type: this.$route.query.type,
									sort: this.$route.query.sort,
								},
								meta: { title: "Topics" },
							},
							{
								name: this.$route.query.redirect,
								meta: {
									title: "...",
									breadcrumbTitle: this.$route.query.testName,
								},
								params: {
									testName: this.$route.query.testName,
									testID: this.$route.query.testID,
									topicName: this.$route.query.topicName,
									topicID: this.$route.query.topicID,
								},
								query: {
									type: this.$route.query.type,
									sort: this.$route.query.sort,
									ttype: this.$route.query.ttype,
									tsort: this.$route.query.tsort,
									status: this.$route.query.status,
								},
							},
						];
					} else {
						codematched = [
							{
								name: "QPcodingTest",
								meta: { title: "QP Coding Test" },
								query: {
									draft: this.$route.query.draft,
								},
							},
						];
					}
					return codematched.concat(matched);
				case "evaluatetest":
					if (this.$route.query.fromRoute == "sandbox") {
						matched.splice(
							0,
							0,
							{
								name: "adminconsole",
								query: {
									type: this.$route.query.type,
								},
								meta: { title: "Admin Console" },
							},
							{
								name: "evaluatetest",
								meta: { title: this.$route.query.emailID },
							}
						);
					} else {
						matched.splice(
							0,
							0,
							{
								path: `/proctoring`,

								meta: { title: "Proctoring" },
							},
							{
								path: `/proctoring/proctortest/${this.$route.params.groupID}/${this.$route.params.candidateType}?name=${this.$route.query.name}`,
								meta: {
									title: this.$route.query.name,
								},
							},
							{
								redirect: `noRedirect`,
								meta: {
									title: this.$route.query.testName,
								},
							},
							{
								redirect: `noRedirect`,
								meta: { title: this.$route.query.userName },
							}
						);
					}
					return matched;
				case "EditCodingTest":
					matched.splice(0, 0, {
						name: "EditCodingTest",
						query: {
							questionKey: this.$route.query.questionKey,
						},
						meta: { title: "Edit Question" },
					});
					if (this.$route.query.redirect == "QPBuilder") {
						editmatched = [
							{
								path: "/",
								query: {
									type: this.$route.query.type,
									sort: this.$route.query.sort,
								},
								meta: { title: "Topics" },
							},
							{
								name: this.$route.query.redirect,
								meta: {
									title: "...",
									breadcrumbTitle: this.$route.query.testName,
								},
								params: {
									testName: this.$route.query.testName,
									testID: this.$route.query.testID,
									topicName: this.$route.query.topicName,
									topicID: this.$route.query.topicID,
								},
								query: {
									type: this.$route.query.type,
									sort: this.$route.query.sort,
									ttype: this.$route.query.ttype,
									tsort: this.$route.query.tsort,
									status: this.$route.query.status,
								},
							},
						];
					} else {
						editmatched = [
							{
								name: "QPcodingTest",
								meta: { title: "QP Coding Test" },
								query: {
									draft: this.$route.query.draft,
								},
							},
						];
					}
					return editmatched.concat(matched);
				default:
					return matched;
			}
		},
	},
	watch: {
		selectedInd(value) {
			this.Assesment = value;
		},
		$route(route) {
			if (route.path.startsWith("/redirect/")) {
				return;
			}
			this.somemethod();
			this.getBreadcrumb();
		},
	},
	created() {
		this.somemethod();
		this.getBreadcrumb();
		this.getCookieData();
		this.getPref();
	},
	methods: {
		async getPref() {
			try {
				const res = await getPreference();
				if (res.status == 200) {
					this.preferences = res.data.data;
					this.selected = this.preferences.defaultModule;
					this.status = this.preferences.dontAskMeAgain;

					console.log(this.status, this.getShowPref);
					if (!this.status && getShowPreference().showPreference) {
						this.checkpref();
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		async setPref() {
			//  this.$store.commit('userVUEX/setShowPref', true)
			try {
				let payload = {
					defaultModule: this.selected,
					dontAskMeAgain: this.status,
				};
				const res = await postPreference(payload);
				if (res.status == 200) {
					this.$bvModal.hide("preferencemodal");
					setShowPreference(getShowPreference());
					this.successToast("Preference updated successfully");
					this.getPref();
				}
			} catch (error) {
				console.log(error);
			}
		},
		checkpref() {
			console.log(this.count);
			if (this.count > 1) {
				this.$nextTick(() => {
					this.$bvModal.show("preferencemodal");
				});
			}
		},
		closeval() {
			// this.$store.commit('userVUEX/setShowPref', true);
			setShowPreference(getShowPreference());
			this.$bvModal.hide("preferencemodal");
			this.getPref();
		},

		closeLog() {
			this.showdpcard = false;
		},
		closeSwitch() {
			this.showswitch = false;
		},
		openRecruit() {
			if (this.accessRecruitment) {
				window.open("https://recruitment.hire3x.com");
			}
		},
		openCan() {
			if (this.accessCandidate) {
				// window.open('http://localhost:8083');
				window.open("https://candidate.hire3x.com?from=candidate");
			}
		},
		openTrain() {
			if (this.accessTraining) {
				window.open("https://trainingadmin.hire3x.com");
			}
		},
		// get access data from cookies
		getCookieData() {
			let data = document.cookie.split(";");
			for (let i in data) {
				let token = data[i].split("=")[0];
				if (token.trim() === "recruitment") {
					this.accessRecruitment = data[i].split("=")[1] !== "no-access";
					this.accessRecruitment ? this.count++ : "";
				}
				if (token.trim() === "training") {
					this.accessTraining = data[i].split("=")[1] !== "no-access";
					this.accessTraining ? this.count++ : "";
				}
				if (token.trim() === "candidate") {
					this.accessCandidate = data[i].split("=")[1] !== "no-access";
					this.accessCandidate ? this.count++ : "";
				}
			}
		},
		configureTest() {
			return (
				this.$route.name == "EditConfigurationTest" ||
				this.$route.name == "ViewConfigurationTest"
			);
		},
		// MAKE THE SIDE BAR WIDTH FIXED
		expandSideBar() {
			this.$store.commit("userVUEX/setMenuStatus", true);
			this.$forceUpdate();
		},

		// CLOSE SIDE BAR
		closeSideBar() {
			this.$store.commit("userVUEX/setMenuStatus", false);
			this.$forceUpdate();
		},

		handleHover(hovered) {
			this.showdpcard = hovered;
		},
		getBreadcrumb() {
			this.levelList = this.switchBreadcrumbs.filter(
				(item) => item.meta?.title && item.meta.breadcrumb !== false
			);
			this.levelList[this.levelList.length - 1].active = true;
		},

		isDashboard(route) {
			const name = route?.route.name;
			if (!name) {
				return false;
			}
			return (
				name.trim().toLocaleLowerCase() === "Dashboard".toLocaleLowerCase()
			);
		},
		pathCompile(path) {
			// To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
			const { params } = this.$route;
			const toPath = compile(path);
			return toPath(params);
		},
		somemethod() {
			this.sharePage = false;
			this.$store.commit("searchVUEX/saveSearchTopicTest", "");
			this.searchTopicTest = "";
			switch (this.$route.name) {
				case "Home":
					this.Assesment = "Topics";
					break;
				case "Tests":
					this.Assesment = "Tests";
					break;
				case "questionbank":
					this.Assesment = "Questions";
					this.sharePage = false;
					break;
				case "Archivetest":
					this.Assesment = "Inactive Tests";
					break;
				case "TestConfiguration":
					this.Assesment = "Test Configuration";
					this.sharePage = true;
					break;
				case "AutogenerateTest":
					this.Assesment = "AutoGenerate Test";
					break;
				case "AccessControl":
					if (this.$route.query.status == "roles") {
						this.Assesment = "Roles";
					} else {
						this.Assesment = "Users";
					}
					break;
				case "ProctoringDashboard":
					this.sharePage = true;
					this.Assesment = "Proctoring";
					break;
				case "OverallAssessment":
					this.Assesment = "Reports";
					this.sharePage = true;
					break;
				case "AutoTestConfiguration":
					this.sharePage = true;
					this.Assesment = "Auto Genearate Test Configuration";
					break;
				case "Group":
					this.Assesment = this.selectedInd;
					break;
				case "ShareWithPeople":
					this.Assesment = this.selectedInd;
					break;
				case "ShareWithPeopleTest":
					this.Assesment = this.selectedInd;
					break;
				case "ShareWithPeopleAutoQPBuilder":
					this.Assesment = this.selectedInd;
					break;
				case "Configure":
					this.Assesment = "Configuration";
					break;
				case "ConfigureTest":
					this.Assesment = "Configuration";
					break;
				case "ConfigureAutoQPBuilder":
					this.Assesment = "Configuration";
					break;
				case "ConfigureAutogenerate":
					this.Assesment = "Configuration";
					break;
				case "ProctorGroups":
					this.Assesment = "Groups";
					break;
				case "ViewProctorTestScreen":
					this.Assesment = "Proctor Test Screen";
					break;
				case "EvaluatorList":
					this.Assesment = "Evaluators";
					break;
				case "myprojects":
					this.Assesment = "Projects";
					break;
				case "adminconsole":
					if (this.$route.query.type == "individual") {
						this.Assesment = "Individual";
					} else {
						this.Assesment = "Group";
					}
					break;
				case "Transaction":
					this.sharePage = true;
					break;
				case "view-code-sandbox":
				case "ViewCandidateProctorScreen":
				case "ParticularTestConfiguration":
				case "ParticularTestConfigurationTest":
				case "ParticularTestConfigurationAutoQPBuilder":
				case "EditConfiguration":
				case "EditConfigurationTest":
				case "EditConfigurationAutoQPBuilder":
				case "EditConfigurationAutogenerate":
				case "ViewConfiguration":
				case "ViewConfigurationTest":
				case "ViewConfigurationAutoQPBuilder":
				case "ViewConfigurationAutogenerate":
				case "AutoQPBuilder":
				case "TopicReport":
				case "IndividualTest":
				case "QPBuilder":
				case "AutogenerateSection":
				case "CandidatePerformance":
				case "ParticularTestConfigurationAutogenerate":
				case "candidateproctor":
				case "AddEvaluator":
				case "EditEvaluator":
				case "QPcodingTest":
				case "BuildingCodeTest":
				case "PreviewCodeTest":
				case "EditCodingTest":
				case "tryCode":
				case "Profile":
				case "404":
				case "editsandbox":
				case "createprojects":
				case "editprojects":
				case "evaluatetest":
					this.sharePage = true;
					break;
				default:
					this.sharePage = false;
			}
		},
		handleLink(item) {
			const { redirect, path, name, query } = item;

			if (redirect) {
				this.$router.push(redirect);
				return;
			}
			if (name) {
				this.$router.push({
					name: name,
					params: item.params,
					query: query,
				});
				return;
			}
			if (path) {
				this.$router.push({
					path: path,
					params: item.params,
					query: query,
				});
				return;
			}
			this.$router.push(this.pathCompile(path));
		},
		logout() {
			this.$store.dispatch("userVUEX/LogOut");
		},
		regfn() {
			this.$keycloakvar.register({ action: "register" });
		},
		accountOpen() {
			this.$keycloakvar.accountManagement();
		},
		forcelogin() {
			this.$keycloakvar.login();
		},
		searchTest() {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.$store.commit(
					"searchVUEX/saveSearchTopicTest",
					this.searchTopicTest
				);
			}, 200);
		},
	},
};
</script>

<style>
.current-proj {
	border: 1px solid rgba(76, 120, 206, 0.5) !important;
	background: #e0eaff;
}
.prefmodal-btns .btn-light {
	border-radius: 4px;
	border: 1px solid var(--gray-300, #d0d5dd);
	color: var(--gray-900, #101828);
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 500;
}
.prefmodal-btns .btn-primary {
	border-radius: 4px;
	background: #4c78ce;
	color: #fff;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
}
.prefmodal-checkbox .custom-control-label {
	position: relative;
	margin-bottom: 0;
	vertical-align: top;
	color: var(--gray-700, #344054);
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
}
.prefmodal-checkbox .custom-control-label::before {
	border-radius: 2px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--White, #fff);
}

.prefmodal-radios .custom-control {
	margin-top: 10px;
}
.prefmodal-radios .custom-control-label::before {
	border-radius: 10px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--White, #fff);
}
.prefmodal-radios .custom-control-label::after {
	top: 2px;
}
.prefmodal-radios .custom-control-label {
	position: relative;
	margin-bottom: 0;
	vertical-align: top;
	color: var(--gray-700, #344054);
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 500;
}
.prefmodalheading {
	color: var(--gray-900, #101828);
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 500;
}
.prefmodal-subhead {
	color: var(--gray-500, #667085);
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 400;
}
/* switch apps design */
.sp-main-container {
	border-radius: 8px;
	background: #e0eaff;
	padding: 4px;
}
.sp-license-container {
	position: absolute;
	border-radius: 12px;
	background: #fff;
	box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),
		0px 20px 24px -4px rgba(16, 24, 40, 0.08);
	padding: 16px;
}
.sp-project-box {
	border-radius: 8px;
	border: 1px solid rgba(128, 128, 128, 0.16);
	display: flex;
	width: 81px;
	height: 68px;
	padding: 18px 24px 18px 25px;
	justify-content: center;
	align-items: center;
}
.sp-headings {
	color: #424242;
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 500;
}
.sp-subheadings {
	color: #667085;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 400;
}
.sp-active-main-container {
	border-radius: 8px;
	border: 1px solid #4c78ce;
	background: #e0eaff;
	padding: 4px;
}

.logout-txt {
	font-weight: 400;
	font-size: 12px;
	color: #696969;
}
#switchapp-popover .popover-body {
	padding: 0px;
}
.disable-dropdown-options {
	background: #ffffff;
	border: 1.26537px solid #f6f6f6;
	box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
	font-weight: 500;
	font-size: 14px;
	font-family: "Poppins", sans-serif;
	color: #c4c4c4;
}
.dropdown-options:hover {
	background: #f9f9f9;
	border: 1.26537px solid #f6f6f6;
	box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
}
.dropdown-options {
	background: #ffffff;
	border: 1.26537px solid #f6f6f6;
	box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
	font-weight: 500;
	font-size: 14px;
	font-family: "Poppins", sans-serif;
	color: #72738e;
}
.dropdown-active {
	background: #ededed;
	border: 1.26537px solid #f6f6f6;
	box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
	font-weight: 500;
	font-size: 14px;
	font-family: "Poppins", sans-serif;
	color: #72738e;
}
.dropdown-sub {
	background: #f9f9f9;
	border: 1.26537px solid #f6f6f6;
	box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
	border-radius: 10px 10px 0px 0px;
}
.dropdown-second {
	background: #f9f9f9;
	border: 1.26537px solid #f6f6f6;
	box-shadow: 0px 2px 10px rgba(196, 196, 196, 0.1);
}
.dropdown-head {
	color: #72738e;
	font-weight: 600;
	font-size: 14px;
}
.logoutbox {
	position: absolute;
	z-index: 7;
	width: 100%;
	right: 0;
	top: 45px;
	padding: 2px;
	background: #ffffff;
	box-shadow: 0px 5.06149px 25.3074px rgba(196, 196, 196, 0.5);
	border-radius: 10px;
}
.username {
	font-weight: 700;
	font-size: 12px;
	color: #72738e;
}
.welcometext {
	font-weight: 400;
	font-size: 12px;
	color: #72738e;
}
.login-det-container {
	background: #ffffff;
	border: 1px solid #f4f4f4;
	border-radius: 9px;
	padding: 10px;
}
.dot-class {
	margin-top: -4px;
}
.search-bar .search-input {
	height: 34px;
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-sizing: border-box;
	box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.2);
	border-radius: 5px;
	padding: 0px 10px 0px 30px !important;
	width: 100%;
}

.search-pos {
	position: absolute;
	top: 5px;
	left: 6px;
}
.z-20 {
	z-index: 98765;
}
.breadcrumb-ellipsis {
	width: 50px !important;
	text-overflow: ellipsis !important;
	white-space: nowrap !important;
	overflow: hidden !important;
}
.breadcrumb-ellipsis2 {
	width: 50px !important;
	text-overflow: ellipsis !important;
	white-space: nowrap !important;
	overflow: hidden !important;
}

.header-class {
	background: #fcfcfc;
	box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
	padding: 0 20px;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 20;
}
.header-main {
	height: 70px;
}
.cv-logo {
	margin-right: 30px;
	margin-left: 23px;
}
.cv-bulders-path {
	padding-left: 9px;
	border-left: 1px solid #3f698e;
}
.cv-bulders-path h6 {
	font-weight: 600;
	font-size: 17px;
	line-height: 17px;
	color: #464667;
	padding-right: 10px;
}
.cv-bulders-path span {
	font-weight: 400;
	font-size: 12px;
	color: #1a4164;
	padding-top: 3px;
}
.btn.regiter-btn {
	width: 99px;
	height: 34px;
	font-weight: 600;
	font-size: 13px;
	line-height: 19px;
	color: #b00101;
	background: #fcfcfc;
	border: 1px solid #b00101;
	box-sizing: border-box;
	border-radius: 3px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	margin-right: 20px;
	box-shadow: unset;
}
.btn.login-btn {
	width: 99px;
	box-shadow: none;
	height: 34px;
	font-weight: 600;
	font-size: 13px;
	line-height: 19px;
	color: #ffffff;
	background: #b00101;
	border-radius: 3px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	border: 1px solid #b00101;
}
.btn-outline-danger:focus,
.btn-danger:focus {
	box-shadow: none !important;
}
.profile-details {
	font-weight: normal;
	font-size: 12px;
	line-height: 18px;
	color: #1a4164;
	margin-right: 10px;
}
.profile-details h6 {
	font-weight: 600;
	font-size: 12px;
	line-height: 18px;
	color: #464667;
}
</style>

<style scoped>
a:hover {
	text-decoration: none !important;
}
.breadcrumb-item + .breadcrumb-item:before {
	float: left;
	padding-right: 0.5rem;
	color: #6c757d;
	content: ">" !important;
}
.no-redirect {
	color: #97a8be;
	cursor: text;
}

.search-input[type="search"]::-webkit-search-cancel-button {
	cursor: pointer;
}

.sp-active-main-container {
	background: #f6f9fb;
	padding: 6px;
	border-radius: 8px;
}
.allproj-dropdown {
	position: absolute;
	right: 0;
	top: 42px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: flex-start;
	align-content: flex-start;
	padding: 16px;
	gap: 16px;
	background: #f6f9fb;
	border-width: 0px 1px 1px 1px;
	border-style: solid;
	border-color: #f6f9fb;
	box-shadow: 0px 83px 33px rgba(0, 0, 0, 0.01),
		0px 47px 28px rgba(0, 0, 0, 0.05), 0px 21px 21px rgba(0, 0, 0, 0.09),
		0px 5px 11px rgba(0, 0, 0, 0.1);
	border-radius: 16px 0px 16px 16px;
	width: 355px;
}

.allproj-card {
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	padding: 12px;
	gap: 8px;
	height: 136px;
	width: 148px;
	background: #ffffff;
	border: 1px solid rgba(224, 224, 224, 0.5);
	border-radius: 8px;
	cursor: pointer;
}

.allproj-card:hover {
	border: 1px solid #20639b;
}
.allproj-card-selected {
	background: #deecf6 !important;
	border: 1px solid #20639b !important;
}
.allproj-card-selected img {
	background: #fff !important;
	border-radius: 50% !important;
}

.allproj-card-head {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: -0.03em;
	color: #20639b;
	backdrop-filter: blur(2px);
}

.allproj-card:hover .allproj-card-head {
	color: #20639b;
}

.allproj-card-subhead {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	color: #333333;
}
</style>
